import { useState, useEffect } from "react";
import React from "react";
import ReactSelect from "react-select";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import {
  Box,
  Button,
  Container,
  Typography,
  Grid,
  TextField,
  Card,
  CardContent,
  Divider,
  Radio,
  FormControlLabel,
  FormControl,
  FormLabel,
  IconButton,
} from "@mui/material";
import Moment from "moment";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";

const PreviewClaim = (props) => {
  // Constants and Initial Setup
  const rights = useSelector((state) => state.login.rights);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };
  const alert = useAlert();

  // States
  const [charges, setCharges] = useState("");
  const [charges1, setCharges1] = useState("");
  const [charges2, setCharges2] = useState("");
  const [charges3, setCharges3] = useState("");
  const [code, setCode] = useState("");
  const [code1, setCode1] = useState("");
  const [code2, setCode2] = useState("");
  const [code3, setCode3] = useState("");
  const [UNIT, setUNIT] = useState("");
  const [UNIT1, setUNIT1] = useState("");
  const [UNIT2, setUNIT2] = useState("");
  const [UNIT3, setUNIT3] = useState("");
  const [ProcedureID, setProcedureID] = useState(0);
  const [ProcedureID1, setProcedureID1] = useState(0);
  const [ProcedureID2, setProcedureID2] = useState(0);
  const [ProcedureID3, setProcedureID3] = useState(0);
  const [d, setD] = useState([]);
  const [d1, setD1] = useState([]);
  const [d2, setD2] = useState([]);
  const [d3, setD3] = useState([]);
  const [dos, setDos] = useState("");
  const [Dos, setDOS] = useState("");
  const [dos1, setDos1] = useState("");
  const [dos2, setDos2] = useState("");
  const [dos3, setDos3] = useState("");
  const [claimId] = useState(props.claimId);
  const [submitting, setSubmitting] = useState(false);
  const [patientid, setPatientid] = useState(false);
  const [patientInsuranceName, setPatientInsuranceName] = useState("");
  const [patientAddress, setPatientAddress] = useState("");
  const [patientDOB, setPatientDOB] = useState(Moment().format("YYYY-MM-DD"));
  const [PatientName, setPatientName] = useState("");
  const [memberid, setMemberid] = useState("");
  const [SecondarMemberid, setSecondarMemberid] = useState("");
  const [SecondarInsuranceName, setSecondarInsuranceName] = useState("");
  const [diagnosisList, setDiagnosisList] = useState([]);
  const [procedureCodeList, setProcedureCodeList] = useState([]);
  const [referringPhysicianList, setReferringPhysicianList] = useState([]);
  const [providers, setProviders] = useState([]);
  const [taxId, setTaxId] = useState("");
  const [npi, setNpi] = useState("");
  const [referringProviderNpi, setReferringProviderNpi] = useState("");
  const [providerError, setProviderError] = useState(false);
  const [assignmentError, setAssignmentError] = useState("");
  const [procedureError, setProcedureError] = useState("");
  const [diagnosisError, setDiagnosisError] = useState("");

  // Form Configuration
  const validationSchema = Yup.object({
    dos: Yup.string().required("DOS is required"),
    patientName: Yup.string().required("Patient is required"),
  });
  const fields = [
    "id",
    "patientId",
    "insuranceName",
    "patientName",
    "billingProvider",
    "attendingPhysician",
    "referringPhysicianName",
    "dos",
    "dos1",
    "dos2",
    "pos",
    "referringPhysicianId",
    "memberId",
    "cpt1",
    "cpt2",
    "practiceId",
    "cpt3",
    "charges1",
    "charges2",
    "charges3",
    "acceptAssignment",
    "dontAcceptAssignment",
    "followUpTime",
    "secondaryPending",
    "submitted",
    "payment",
    "referringPhysician",
    "authNumber",
    "frontnote",
    "backnote",
    "renderingProvider",
    "amountDue",
    "discount",
    "additionalInformation",
    "writeOff",
    "claimTotal",
    "amountPaid",
    "compeleted",
    "payment",
    "amountAllowed",
    "totalCharges",
    "adjustments",
    "Carries",
    "referringProvider",
    "createdDate",
    "updatedDate",
    "statusType",
  ];

  const defValues = {
    id: 0,
    patientId: 0,
    billingProvider: 0,
    attendingPhysician: 0,
    insuranceName: "",
    memberId: 0,
    referringPhysician: 0,
    practiceId: "",
    patientName: "",
    dos: "",
    dos1: "",
    dos2: "",
    pos: "",
    frontnote: "",
    amountDue: 0,
    discount: 0,
    writeOff: 0,
    claimTotal: 0,
    amountPaid: 0,
    amountAllowed: 0,
    totalCharges: 0,
    adjustments: 0,
    backnote: "",
    referringPhysicianName: "",
    referringPhysicianId: 0,
    renderingProvider: "",
    cpt1: "",
    cpt2: "",
    cpt3: "",
    charges1: "",
    charges2: "",
    charges3: "",
    authNumber: "",
    acceptAssignment: "",
    dontAcceptAssignment: "",
    followUpTime: "14",
    secondaryPending: "",
    additionalInformation: "",
    submitted: false,
    payment: false,
    Carries: "",
    referringProvider: "",
    createdDate: "",
    updatedDate: "",
    compeleted: false,
    statusType: "Pending",
    diagnosis: {
      id: 0,
      claimId: 0,
      diagSequence: 0,
      description: "",
      code: "",
      dx1: "",
      dx2: "",
      dx3: "",
      dx4: "",
      dx5: "",
      dx6: "",
      dx7: "",
      dx8: "",
      dx9: "",
      dx10: "",
      dx11: "",
      dx12: "",
      patientId: 0,
    },
  };
  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const attendingPhysician = watch("attendingPhysician");
  const referringPhysician = watch("referringPhysician");
  const practiceID = localStorage.getItem("default_paractice");
  const User_Type = localStorage.getItem("User_Type");
  const claimPracticeID = props.claimPracticeID;
  const PatientidOfClaim = props.claimpatientId || props.patientId;

  // UI Styling Constants
  const styles = {
    container: {
    //   padding: "20px 0",
      backgroundColor: "#f8f9fa",
      minHeight: "100vh",
    },
    header: {
      background: "linear-gradient(135deg, #4b79a1 0%, #283e51 100%)", // new premium gradient
      color: "white",
      padding: "18px 24px",
      borderRadius: "14px",
      marginBottom: "30px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    sectionCard: {
      padding: "24px",
      marginBottom: "24px",
      borderRadius: "12px",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
      border: "1px solid #e0e0e0",
      transition: "all 0.3s ease",
      "&:hover": {
        boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
      },
    },
    sectionHeader: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#1976d2",
      marginBottom: "20px",
      paddingBottom: "12px",
      borderBottom: "2px solid #1976d2",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    formLabel: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#333",
      marginBottom: "8px",
      display: "block",
    },
    inputField: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1976d2",
        },
      },
      "& .MuiInputBase-input": {
        padding: "12px 14px",
        fontSize: "14px",
      },
      "& .MuiInputLabel-root": {
        fontSize: "14px",
      },
    },
    selectField: {
      "& .css-1s2u09g-control": {
        borderRadius: "8px",
        minHeight: "44px",
        borderColor: "#ced4da",
        "&:hover": {
          borderColor: "#1976d2",
        },
      },
    },
    buttonPrimary: {
      background: "linear-gradient(135deg, #1976d2 0%, #115293 100%)",
      color: "white",
      padding: "12px 32px",
      borderRadius: "8px",
      fontWeight: "600",
      fontSize: "14px",
      textTransform: "none",
      boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.4)",
        transform: "translateY(-1px)",
      },
      "&:disabled": {
        background: "#cccccc",
        boxShadow: "none",
      },
    },
    buttonIcon: {
      marginRight: "8px",
      fontSize: "20px",
    },
    errorText: {
      color: "#d32f2f",
      fontSize: "12px",
      marginTop: "4px",
      marginLeft: "2px",
    },
    checkboxGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      padding: "16px",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      border: "1px solid #e0e0e0",
    },
    claimDetailRow: {
      backgroundColor: "#f8f9fa",
      padding: "16px",
      borderRadius: "8px",
      marginBottom: "16px",
      border: "1px solid #e0e0e0",
    },
    insuranceSection: {
      backgroundColor: "#f0f7ff",
      padding: "20px",
      borderRadius: "8px",
      marginBottom: "20px",
    },
  };

  // Effects
  useEffect(() => {
    if (patientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${patientid}`,
          { headers }
        )
        .then((response) => {
          const Data = response[0];
          const fullAddress = [
            Data.address,
            Data.city,
            Data.state,
            Data.zipCode,
          ]
            .filter(Boolean)
            .join(", ");
          const primary = response.find(
            (r) => r.type?.toLowerCase() === "primary"
          );
          const secondary = response.find(
            (r) => r.type?.toLowerCase() === "secondary"
          );

          setPatientInsuranceName(primary?.planName || "");
          setPatientAddress(fullAddress);
          setPatientDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setMemberid(primary?.memberId || "");
          setPatientName(Data.patientName);
          setSecondarInsuranceName(secondary?.planName || "");
          setSecondarMemberid(secondary?.memberId || "");
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }, [patientid]);

  useEffect(() => {
    if (claimId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/claims/ClaimsById?claimId=${claimId}`,
          { headers }
        )
        .then((response) => {
          fields.forEach((field) => setValue(field, response[field]));
          setPatientid(response.patientId);

          const dateto342 = Moment(response.dos).format("YYYY-MM-DD");
          setDOS(dateto342);

          const procedures = response.procedures || [];

          if (procedures[0]) {
            setCharges(procedures[0].charges);
            setCode(procedures[0].code);
            setD(
              procedures[0].dxPointer1?.split(",").map((code) => code.trim()) ||
                []
            );
            const rawDates = procedures[0]?.dosTo;
            const dateto1 = Moment(rawDates, Moment.ISO_8601, true).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos(dateto1);
            setProcedureID(procedures[0].id);
          }
          if (procedures[1]) {
            setCharges1(procedures[1].charges);
            setCode1(procedures[1].code);
            setD1(
              procedures[1].dxPointer1?.split(",").map((code) => code.trim()) ||
                []
            );
            const rawDates = procedures[1]?.dosTo;
            const dateto2 = Moment(rawDates, Moment.ISO_8601, true).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos1(dateto2);
            setProcedureID1(procedures[0].id);
          }
          if (procedures[2]) {
            setCharges2(procedures[2].charges);
            setCode2(procedures[2].code);
            setD2(
              procedures[2].dxPointer1?.split(",").map((code) => code.trim()) ||
                []
            );
            const rawDates = procedures[2]?.dosTo;
            const dateto342123 = Moment(
              rawDates,
              Moment.ISO_8601,
              true
            ).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos2(dateto342123);
            setProcedureID2(procedures[0].id);
          }

          // Similar handling for procedures[1], [2], [3]...
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }, [claimId]);

  useEffect(() => {
    // Fetch diagnosis list
    axios
      .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, { headers })
      .then((response) => {
        const diagnosisOptions = response.map((field) => ({
          label: field.code,
          value: field.id,
        }));
        setDiagnosisList(diagnosisOptions);
      })
      .catch(console.error);

    // Fetch procedure codes
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers,
      })
      .then((response) => {
        const procedureOptions = response.map((field) => ({
          label: field.code,
          value: field.code,
          qasim: field.default_charges,
          unit: field.unit,
        }));
        setProcedureCodeList(procedureOptions);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    const endpoint =
      !claimPracticeID || claimPracticeID === practiceID
        ? `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?parcticeid=${practiceID}`
        : `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?patientid=${PatientidOfClaim}`;

    axios
      .get(endpoint, { headers })
      .then((response) => {
        const referringOptions = response.map((field) => ({
          label: `${field.lastName}, ${field.firstName}`,
          value: field.id,
          npi: field.npi,
        }));
        setReferringPhysicianList(referringOptions);
      })
      .catch(console.error);
  }, [practiceID, PatientidOfClaim, claimPracticeID]);

  useEffect(() => {
    const endpoint =
      !claimPracticeID || claimPracticeID === practiceID
        ? `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?parcticeid=${practiceID}`
        : `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?patientid=${PatientidOfClaim}`;

    axios
      .get(endpoint, { headers })
      .then((response) => {
        const providerOptions = response.map((field) => ({
          label: field.name || `${field.firstName}, ${field.lastName}`,
          value: field.id,
          npi: field.npi || field.nPI,
          taxId: field.taxId,
        }));
        setProviders(providerOptions);
      })
      .catch(console.error);
  }, [practiceID, claimPracticeID, PatientidOfClaim]);

  useEffect(() => {
    if (attendingPhysician && providers.length > 0) {
      const selectedProvider = providers.find(
        (option) => option.value === attendingPhysician
      );
      if (selectedProvider) {
        setNpi(selectedProvider.npi);
        setTaxId(selectedProvider.taxId);
      }
    }
  }, [attendingPhysician, providers]);

  useEffect(() => {
    if (referringPhysician && referringPhysicianList.length > 0) {
      const selected = referringPhysicianList.find(
        (p) => String(p.value) === String(referringPhysician)
      );
      if (selected) {
        setReferringProviderNpi(selected.npi);
      }
    }
  }, [referringPhysicianList, referringPhysician]);

  // Submit Handler
  const onSubmit = (data) => {
    let isValid = true;

    if (!code) {
      setProcedureError("Procedure code is required.");
      isValid = false;
    } else {
      setProcedureError("");
    }

    if (d.length === 0) {
      setDiagnosisError("At least one diagnosis code is required.");
      isValid = false;
    } else {
      setDiagnosisError("");
    }

    if (!isValid) return;

    if (!data.acceptAssignment && !data.dontAcceptAssignment) {
      setAssignmentError("Please select one option.");
      return;
    }

    setAssignmentError("");

    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true,
      dontAcceptAssignment: data.dontAcceptAssignment === true,
      payment: false,
      authNumber: data.authNumber,
      practiceId: data.practiceId,
      patientName: PatientName,
      compeleted: true,
      patientId: patientid > 0 ? patientid : patientid,
      totalCharges:
        (parseFloat(charges) || 0) +
        (parseFloat(charges1) || 0) +
        (parseFloat(charges2) || 0) +
        (parseFloat(charges3) || 0),
    };

    if (claimId > 0) {
      postData.amountDue = postData.totalCharges;
    }

    const DiagnosisCode = [
      Array.isArray(d) ? d.join(",") : "",
      Array.isArray(d1) ? d1.join(",") : "",
      Array.isArray(d2) ? d2.join(",") : "",
      Array.isArray(d3) ? d3.join(",") : "",
    ];

    const DOS = [Dos, dos1, dos2, dos3];
    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];
    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];

    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
      })
    );

    setSubmitting(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        setSubmitting(false);
        props.CloseModal();
        props.applyRefresh();
        setTimeout(() => {
          alert.success("Record saved successfully.", { type: "success" });
        }, 500);
      })
      .catch((error) => {
        setSubmitting(false);
        props.CloseModal();
        alert.error("Error saving record. Please try again.", {
          type: "error",
        });
      });
  };

  return (
    <Box sx={styles.container}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={styles.header}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, color: "#fff", letterSpacing: "0.5px" }}
          >
            Review & Submit Claim
          </Typography>

          <IconButton
          onClick={props.handleClosePreview}
            sx={{
              color: "#fff",
              background: "rgba(255,255,255,0.15)",
              borderRadius: "8px",
              padding: "6px",
              transition: "0.3s",
              "&:hover": {
                background: "rgba(255,255,255,0.25)",
                transform: "scale(1.05)",
              },
            }}
          >
            <CancelOutlinedIcon />
          </IconButton>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Provider Information */}
          <Card sx={styles.sectionCard}>
            <Typography sx={styles.sectionHeader}>
              Provider Information
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Typography sx={styles.formLabel}>Provider Name *</Typography>
                <Controller
                  name="attendingPhysician"
                  control={control}
                  render={({ field }) => (
                    <Box sx={styles.selectField}>
                      <ReactSelect
                        {...field}
                        value={providers.find(
                          (option) => option.value === field.value
                        )}
                        onChange={(value) => {
                          field.onChange(value.value);
                          setProviderError(false);
                        }}
                        options={providers}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: "300px", // max height of dropdown
                            overflowY: "auto", // enable scroll if options exceed
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "300px",
                          }),
                        }}
                        menuPosition="fixed"
                      />
                    </Box>
                  )}
                />
                {providerError && (
                  <Typography sx={styles.errorText}>
                    Please select Provider
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography sx={styles.formLabel}>Provider TIN</Typography>
                <TextField
                  fullWidth
                  value={taxId}
                  InputProps={{ readOnly: true }}
                  sx={styles.inputField}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography sx={styles.formLabel}>Provider NPI</Typography>
                <TextField
                  fullWidth
                  value={npi}
                  InputProps={{ readOnly: true }}
                  sx={styles.inputField}
                />
              </Grid>
            </Grid>
          </Card>

          {/* Patient Information */}
          <Card sx={styles.sectionCard}>
            <Typography sx={styles.sectionHeader}>
              Patient Information
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Typography sx={styles.formLabel}>Patient Name *</Typography>
                <TextField
                  {...register("patientName")}
                  fullWidth
                  value={PatientName}
                  error={!!errors.patientName}
                  helperText={errors.patientName?.message}
                  sx={styles.inputField}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography sx={styles.formLabel}>Date of Birth</Typography>
                <TextField
                  fullWidth
                  type="date"
                  value={patientDOB}
                  InputProps={{ readOnly: true }}
                  sx={styles.inputField}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography sx={styles.formLabel}>Address</Typography>
                <TextField
                  fullWidth
                  value={patientAddress}
                  InputProps={{ readOnly: true }}
                  sx={styles.inputField}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography sx={styles.formLabel}>
                  Referring Physician
                </Typography>
                <Controller
                  name="referringPhysician"
                  control={control}
                  render={({ field }) => (
                    <Box sx={styles.selectField}>
                      <ReactSelect
                        {...field}
                        value={referringPhysicianList.find(
                          (option) => option.value === field.value
                        )}
                        onChange={(value) => field.onChange(value.value)}
                        options={referringPhysicianList}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: "300px", // max height of dropdown
                            overflowY: "auto", // enable scroll if options exceed
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "300px",
                          }),
                        }}
                        menuPosition="fixed"
                      />
                    </Box>
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography sx={styles.formLabel}>
                  Referring Provider NPI
                </Typography>
                <TextField
                  fullWidth
                  value={referringProviderNpi}
                  InputProps={{ readOnly: true }}
                  sx={styles.inputField}
                />
              </Grid>
            </Grid>
          </Card>

          {/* Insurance Information */}
          <Box sx={styles.insuranceSection}>
            <Typography sx={{ ...styles.sectionHeader, color: "#0d47a1" }}>
              Insurance Information
            </Typography>

            <Grid container spacing={3}>
              {/* Primary Insurance */}
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    p: 2,
                    backgroundColor: "#e8f5e9",
                    border: "1px solid #c8e6c9",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, color: "#2e7d32", mb: 2 }}
                  >
                    Primary Insurance
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography sx={styles.formLabel}>
                        Insurance Company
                      </Typography>
                      <TextField
                        fullWidth
                        value={patientInsuranceName}
                        InputProps={{ readOnly: true }}
                        sx={styles.inputField}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography sx={styles.formLabel}>Member ID</Typography>
                      <TextField
                        fullWidth
                        value={memberid}
                        InputProps={{ readOnly: true }}
                        sx={styles.inputField}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              {/* Secondary Insurance */}
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    p: 2,
                    backgroundColor: "#fff3e0",
                    border: "1px solid #ffcc80",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, color: "#f57c00", mb: 2 }}
                  >
                    Secondary Insurance
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography sx={styles.formLabel}>
                        Insurance Company
                      </Typography>
                      <TextField
                        fullWidth
                        value={SecondarInsuranceName}
                        InputProps={{ readOnly: true }}
                        sx={styles.inputField}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography sx={styles.formLabel}>Member ID</Typography>
                      <TextField
                        fullWidth
                        value={SecondarMemberid}
                        InputProps={{ readOnly: true }}
                        sx={styles.inputField}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* Claim Details */}
          <Card sx={styles.sectionCard}>
            <Typography sx={styles.sectionHeader}>Claim Details</Typography>

            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={6}>
                <Typography sx={styles.formLabel}>
                  Date of Service (DOS) *
                </Typography>
                <Controller
                  name="dos"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="date"
                      fullWidth
                      value={Dos}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setDOS(e.target.value);
                        setDos(e.target.value);
                      }}
                      error={!!errors.dos}
                      helperText={errors.dos?.message}
                      sx={styles.inputField}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography sx={styles.formLabel}>
                  Authorization Number
                </Typography>
                <Controller
                  name="authNumber"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      placeholder="Enter authorization number"
                      sx={styles.inputField}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Card>
          {/* Procedure Details Section - COMPLETE FIXED VERSION */}
          <Card sx={styles.sectionCard}>
            <Typography sx={styles.sectionHeader}>Procedure Details</Typography>

            {/* <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={6}>
                <Typography sx={styles.formLabel}>
                  Date of Service (DOS) *
                </Typography>
                <Controller
                  name="dos"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="date"
                      fullWidth
                      value={Dos}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setDOS(e.target.value);
                        setDos(e.target.value);
                      }}
                      error={!!errors.dos}
                      helperText={errors.dos?.message}
                      sx={styles.inputField}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography sx={styles.formLabel}>
                  Authorization Number
                </Typography>
                <Controller
                  name="authNumber"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      placeholder="Enter authorization number"
                      sx={styles.inputField}
                    />
                  )}
                />
              </Grid>
            </Grid> */}

            {/* <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "#555" }}
            >
              Procedure Line Items
            </Typography> */}

            {/* Row 1 - Procedure 1 */}
            <Box sx={styles.claimDetailRow}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Procedure Code 1 *
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      value={
                        procedureCodeList.find(
                          (option) => option.value === code
                        ) || (code ? { label: code, value: code } : null)
                      }
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setCode(selectedOption.value);
                          setCharges(selectedOption.qasim);
                          setValue("cpt1", selectedOption.value);
                          setUNIT(selectedOption.unit);
                          setProcedureError("");
                        } else {
                          setCode("");
                          setCharges("");
                          setValue("cpt1", "");
                          setUNIT("");
                        }
                      }}
                      options={procedureCodeList}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "44px",
                        }),
                      }}
                      isClearable
                    />
                  </Box>
                  {procedureError && (
                    <Typography sx={styles.errorText}>
                      {procedureError}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Diagnosis Code 1 *
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      isMulti
                      value={d.map((dxCode) => {
                        const found = diagnosisList.find(
                          (option) => String(option.value) === String(dxCode)
                        );
                        return found || { label: dxCode, value: dxCode };
                      })}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions
                          ? selectedOptions.map((opt) => String(opt.value))
                          : [];
                        setD(selectedValues);
                        setDiagnosisError(
                          selectedValues.length === 0
                            ? "At least one diagnosis code is required."
                            : ""
                        );
                      }}
                      options={diagnosisList}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "44px",
                        }),
                      }}
                    />
                  </Box>
                  {diagnosisError && (
                    <Typography sx={styles.errorText}>
                      {diagnosisError}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>DOS 1</Typography>
                  <TextField
                    type="date"
                    fullWidth
                    value={dos}
                    onChange={(e) => {
                      setDos(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>Charge $ 1</Typography>
                  <TextField
                    fullWidth
                    value={charges}
                    onChange={(e) => {
                      setCharges(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Row 2 - Procedure 2 */}
            <Box sx={styles.claimDetailRow}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Procedure Code 2
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      value={
                        procedureCodeList.find(
                          (option) => option.value === code1
                        ) || (code1 ? { label: code1, value: code1 } : null)
                      }
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setCode1(selectedOption.value);
                          setCharges1(selectedOption.qasim);
                          setValue("cpt2", selectedOption.value);
                          setUNIT1(selectedOption.unit);
                        } else {
                          setCode1("");
                          setCharges1("");
                          setValue("cpt2", "");
                          setUNIT1("");
                        }
                      }}
                      options={procedureCodeList}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "44px",
                        }),
                      }}
                      isClearable
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Diagnosis Code 2
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      isMulti
                      value={d1.map((dxCode) => {
                        const found = diagnosisList.find(
                          (option) => String(option.value) === String(dxCode)
                        );
                        return found || { label: dxCode, value: dxCode };
                      })}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions
                          ? selectedOptions.map((opt) => String(opt.value))
                          : [];
                        setD1(selectedValues);
                      }}
                      options={diagnosisList}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "44px",
                        }),
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>DOS 2</Typography>
                  <TextField
                    type="date"
                    fullWidth
                    value={dos1}
                    onChange={(e) => {
                      setDos1(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>Charge $ 2</Typography>
                  <TextField
                    fullWidth
                    value={charges1}
                    onChange={(e) => {
                      setCharges1(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Row 3 - Procedure 3 */}
            <Box sx={styles.claimDetailRow}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Procedure Code 3
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      value={
                        procedureCodeList.find(
                          (option) => option.value === code2
                        ) || (code2 ? { label: code2, value: code2 } : null)
                      }
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setCode2(selectedOption.value);
                          setCharges2(selectedOption.qasim);
                          setValue("cpt3", selectedOption.value);
                          setUNIT2(selectedOption.unit);
                        } else {
                          setCode2("");
                          setCharges2("");
                          setValue("cpt3", "");
                          setUNIT2("");
                        }
                      }}
                      options={procedureCodeList}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: "200px", // max height of dropdown
                          overflowY: "auto", // enable scroll if options exceed
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "200px",
                        }),
                      }}
                      isClearable
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Diagnosis Code 3
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      isMulti
                      value={d2.map((dxCode) => {
                        const found = diagnosisList.find(
                          (option) => String(option.value) === String(dxCode)
                        );
                        return found || { label: dxCode, value: dxCode };
                      })}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions
                          ? selectedOptions.map((opt) => String(opt.value))
                          : [];
                        setD2(selectedValues);
                      }}
                      options={diagnosisList}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "44px",
                        }),
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>DOS 3</Typography>
                  <TextField
                    type="date"
                    fullWidth
                    value={dos2}
                    onChange={(e) => {
                      setDos2(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>Charge $ 3</Typography>
                  <TextField
                    fullWidth
                    value={charges2}
                    onChange={(e) => {
                      setCharges2(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Row 4 - Procedure 4 */}
            <Box sx={styles.claimDetailRow}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Procedure Code 4
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      value={
                        procedureCodeList.find(
                          (option) => option.value === code3
                        ) || (code3 ? { label: code3, value: code3 } : null)
                      }
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setCode3(selectedOption.value);
                          setCharges3(selectedOption.qasim);
                          setValue("cpt3", selectedOption.value);
                          setUNIT3(selectedOption.unit);
                        } else {
                          setCode3("");
                          setCharges3("");
                          setValue("cpt3", "");
                          setUNIT3("");
                        }
                      }}
                      options={procedureCodeList}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 999999,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 999999,
                          maxHeight: "200px",
                          overflowY: "auto",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "200px",
                        }),
                      }}
                      isClearable
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>
                    Diagnosis Code 4
                  </Typography>
                  <Box sx={styles.selectField}>
                    <ReactSelect
                      isMulti
                      value={d3.map((dxCode) => {
                        const found = diagnosisList.find(
                          (option) => String(option.value) === String(dxCode)
                        );
                        return found || { label: dxCode, value: dxCode };
                      })}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions
                          ? selectedOptions.map((opt) => String(opt.value))
                          : [];
                        setD3(selectedValues);
                      }}
                      options={diagnosisList}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 999999,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 999999,
                          maxHeight: "200px",
                          overflowY: "auto",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "200px",
                        }),
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>DOS 4</Typography>
                  <TextField
                    type="date"
                    fullWidth
                    value={dos3}
                    onChange={(e) => {
                      setDos3(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={styles.formLabel}>Charge $ 4</Typography>
                  <TextField
                    fullWidth
                    value={charges3}
                    onChange={(e) => {
                      setCharges3(e.target.value);
                    }}
                    sx={styles.inputField}
                  />
                </Grid>
              </Grid>
            </Box>
          </Card>
          {/* Notes Section */}
          <Card sx={styles.sectionCard}>
            <Typography sx={styles.sectionHeader}>
              Notes & Additional Information
            </Typography>

            <Grid container spacing={3}>
              {rights.Claims_FrontOffice_Notes && (
                <Grid item xs={12} md={6}>
                  <Typography sx={styles.formLabel}>
                    Front Office Notes
                  </Typography>
                  <Controller
                    name="frontnote"
                    control={control}
                    render={({ field }) => (
                      <TextareaAutosize
                        {...field}
                        minRows={2}
                        placeholder="Enter front office notes"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "1px solid #ced4da",
                          padding: "12px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          resize: "vertical",
                        }}
                      />
                    )}
                  />
                </Grid>
              )}

              {rights.Claims_BackOffice_Notes && (
                <Grid item xs={12} md={6}>
                  <Typography sx={styles.formLabel}>
                    Back Office Notes
                  </Typography>
                  <Controller
                    name="backnote"
                    control={control}
                    render={({ field }) => (
                      <TextareaAutosize
                        {...field}
                        minRows={2}
                        placeholder="Enter back office notes"
                        onChange={(e) => {
                          field.onChange(e);
                          setValue("followUpTime", "14");
                        }}
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "1px solid #ced4da",
                          padding: "12px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          resize: "vertical",
                        }}
                      />
                    )}
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <Typography sx={styles.formLabel}>
                  Additional Information
                </Typography>
                <Controller
                  name="additionalInformation"
                  control={control}
                  render={({ field }) => (
                    <TextareaAutosize
                      {...field}
                      minRows={2}
                      placeholder="Enter any additional information"
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #ced4da",
                        padding: "12px",
                        fontSize: "14px",
                        fontFamily: "inherit",
                        resize: "vertical",
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Card>

          {/* Assignment Options */}
          <Card sx={styles.sectionCard}>
            <Typography sx={styles.sectionHeader}>
              Assignment & Follow-up Options
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box sx={styles.checkboxGroup}>
                  <Typography sx={{ fontWeight: 600, mb: 2, color: "#333" }}>
                    Assignment Options
                  </Typography>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <input
                      type="checkbox"
                      {...register("acceptAssignment")}
                      id="acceptAssignment"
                      style={{ width: "18px", height: "18px" }}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setValue("acceptAssignment", checked);
                        setValue("dontAcceptAssignment", !checked);
                        setAssignmentError("");
                      }}
                    />
                    <Typography
                      component="label"
                      htmlFor="acceptAssignment"
                      style={{ fontSize: "14px", cursor: "pointer", flex: 1 }}
                    >
                      <b>Accept Assignment</b> - Payment will go directly to
                      your office
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <input
                      type="checkbox"
                      {...register("dontAcceptAssignment")}
                      id="dontAcceptAssignment"
                      style={{ width: "18px", height: "18px" }}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setValue("dontAcceptAssignment", checked);
                        setValue("acceptAssignment", !checked);
                        setAssignmentError("");
                      }}
                    />
                    <Typography
                      component="label"
                      htmlFor="dontAcceptAssignment"
                      style={{ fontSize: "14px", cursor: "pointer", flex: 1 }}
                    >
                      <b>Do NOT Accept Assignment</b> - Payment issued to the
                      patient
                    </Typography>
                  </Box>

                  {assignmentError && (
                    <Typography sx={{ ...styles.errorText, mt: 1 }}>
                      {assignmentError}
                    </Typography>
                  )}
                </Box>

                {/* Status Options for existing claims */}
                {claimId > 0 && (
                  <Box
                    sx={{
                      mt: 3,
                      p: 2,
                      backgroundColor: "#f0f7ff",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: 600, mb: 2, color: "#1976d2" }}
                    >
                      Save Options
                    </Typography>
                    <Box sx={{ display: "flex", gap: 3 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <input
                          type="radio"
                          id="savePending"
                          value="Pending"
                          {...register("statusType")}
                          style={{ width: "18px", height: "18px" }}
                        />
                        <Typography
                          component="label"
                          htmlFor="savePending"
                          style={{ fontSize: "14px", cursor: "pointer" }}
                        >
                          <b>Save as Pending</b>
                        </Typography>
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <input
                          type="radio"
                          id="saveSecondaryPending"
                          value="Secondary Pending"
                          {...register("statusType")}
                          style={{ width: "18px", height: "18px" }}
                        />
                        <Typography
                          component="label"
                          htmlFor="saveSecondaryPending"
                          style={{ fontSize: "14px", cursor: "pointer" }}
                        >
                          <b>Save as Secondary Pending</b>
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Grid>

              {User_Type !== "Front Office" &&
                User_Type !== "Front Office Admin" && (
                  <Grid item xs={12} md={6}>
                    <Box sx={styles.checkboxGroup}>
                      <Typography
                        sx={{ fontWeight: 600, mb: 2, color: "#333" }}
                      >
                        Follow-up Time
                      </Typography>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <input
                          type="radio"
                          value="14"
                          {...register("followUpTime")}
                          id="defaultTwoweek"
                          style={{ width: "18px", height: "18px" }}
                        />
                        <Typography
                          component="label"
                          htmlFor="defaultTwoweek"
                          style={{ fontSize: "14px", cursor: "pointer" }}
                        >
                          Default Follow Up Time (2 Weeks)
                        </Typography>
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <input
                          type="radio"
                          value="5"
                          {...register("followUpTime")}
                          id="FollowUp5Days"
                          style={{ width: "18px", height: "18px" }}
                        />
                        <Typography
                          component="label"
                          htmlFor="FollowUp5Days"
                          style={{ fontSize: "14px", cursor: "pointer" }}
                        >
                          Follow Up 5 Days
                        </Typography>
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <input
                          type="radio"
                          value="10"
                          {...register("followUpTime")}
                          id="FollowUp10Days"
                          style={{ width: "18px", height: "18px" }}
                        />
                        <Typography
                          component="label"
                          htmlFor="FollowUp10Days"
                          style={{ fontSize: "14px", cursor: "pointer" }}
                        >
                          Follow Up 10 Days
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                )}
            </Grid>
          </Card>

          {/* Submit Button */}
          <Box sx={{ mt: 4, mb: 6, display: "flex", justifyContent: "center" }}>
            <Button
              type="submit"
              variant="contained"
              disabled={submitting}
              sx={styles.buttonPrimary}
              startIcon={<SaveOutlinedIcon sx={styles.buttonIcon} />}
            >
              {submitting ? "Saving..." : "Save Claim"}
            </Button>
          </Box>
        </form>
      </Container>
    </Box>
  );
};

export default PreviewClaim;
